/**
 * Business User API
 * @description User management for SuperAdmin
 */
import { request } from '@umijs/max';

const BASE_PATH = '/api/users';

/** Get all MerchantOwner users with their partner summaries */
export async function getMerchantOwners(options?: { [key: string]: any }) {
  return request<BusinessAPI.ListResponse<BusinessAPI.MerchantOwner>>(
    `${BASE_PATH}/merchant-owners`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** Get partners for a specific user (SuperAdmin impersonation) */
export async function getUserMerchants(
  userId: number,
  options?: { [key: string]: any },
) {
  return request<BusinessAPI.ListResponse<BusinessAPI.Partner>>(
    `${BASE_PATH}/${userId}/merchants`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
